import { useRecoilValue } from "recoil"
import { HIGH_VIDEO_STREAM_TYPE, LOW_VIDEO_STREAM_TYPE } from "../../constants"
import { MainVideoStreamTypeAtom } from "../../recoil/atoms/remoteVideoStreamType"
import MOLocation from "../../util/MOLocation"

const useMainVideoStreamType = () => {
  const mainVideoStreamType = useRecoilValue(MainVideoStreamTypeAtom)
  const type = MOLocation.getURLParamValue("mainVideoStreamType")

  if (type === "low") {
    return LOW_VIDEO_STREAM_TYPE
  }

  if (type === "high") {
    return HIGH_VIDEO_STREAM_TYPE
  }

  return mainVideoStreamType
}

export default useMainVideoStreamType
